import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import * as yup from 'yup';

import { updateItinerary } from 'actions/adminTool';
import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useToast from 'hooks/useToast';

import { Container, Wrapper, FormContainer, Field } from './styles';
import useStoreTranslation from 'hooks/useStoreTranslation';

const AdminToolUpdateItinerary = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      
      const itineraryUpdated = await updateItinerary(
        values.travelItineraryId,
      );

      if (itineraryUpdated.data.succeeded) {
        toast.add({ type: 'success', message: t('adminTool.updateItineraryForm.toastSuccess') });
      } else {
        toast.add({ type: 'danger', message: itineraryUpdated.data?.errors[0] ?? '' });
      }
      
    } catch (error: any) {
            
        let errorMessage = 'An unexpected error occurred.';
    
        // Verifica se o erro é uma instância de Error
        if (error instanceof Error) {
          errorMessage = error.message;
        }
    
        // Verifica se há uma resposta de erro da API
        if (error?.response?.data?.error) {
          errorMessage += ` - ${error.response.data.error}`;
        }
    
        toast.add({ type: 'danger', message: errorMessage });
      }

    setIsLoading(false);
  };

  const validationSchema = yup.object().shape({
    travelItineraryId: yup.string().required()
  });

  const initValues = {
    travelItineraryId: ''
  };

  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/admintool')}>{t('adminTool.updateItineraryForm.title')}</Header>
        </Mobile>

        <Desktop>      
          <ScreenHeader title={t('adminTool.updateItineraryForm.title')} subtitle={t('adminTool.updateItineraryForm.subtitle')} />
        </Desktop>

        <Container>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({ dirty, isSubmitting, isValid, values, setFieldValue }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />
                <FormContainer marginBottom={dirty}>
                  <Section title={t('adminTool.updateItineraryForm.parameters')} joinContent={true}>
                    <Field name="travelItineraryId" label={t('adminTool.updateItineraryForm.itineraryId')}>
                      <Input placeholder="" />
                    </Field>
                    
                    <br />
                    <br />
                  </Section>
                  <SubmitButton dirty={true} isEdit loading={isLoading}>
                    {t('adminTool.updateItineraryForm.button')}
                  </SubmitButton>                
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default AdminToolUpdateItinerary;
